(function () {

  const WRAP_HANDLE = 'gaveinnpakning';

  const root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';


  function isGiftWrap(item) {

    return item.handle === WRAP_HANDLE;

  }


  async function getCart() {

    const response = await fetch(
      root + 'cart.js',
      {
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      throw new Error('Kunne ikke kontrollere handlekurven.');
    }

    return response.json();

  }


  function showGiftWrapError(message, checkoutElement) {

    let box =
      document.getElementById('GiftWrapCartError');

    if (!box) {

      box = document.createElement('div');

      box.id = 'GiftWrapCartError';

      box.style.padding = '14px 16px';
      box.style.margin = '15px 0';
      box.style.border = '1px solid currentColor';
      box.style.borderRadius = '8px';
      box.style.fontWeight = '600';
      box.style.lineHeight = '1.45';

      if (
        checkoutElement &&
        checkoutElement.parentNode
      ) {

        checkoutElement.parentNode.insertBefore(
          box,
          checkoutElement
        );

      } else {

        document.body.appendChild(box);

      }

    }

    box.textContent = message;

    box.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

  }


  function continueCheckout(element) {

    element.dataset.giftWrapValidated = 'yes';

    if (element.tagName === 'A') {

      window.location.href = element.href;

    } else {

      element.click();

    }

  }


  document.addEventListener(
    'click',
    async function (event) {

      const checkoutElement =
        event.target.closest(
          'button[name="checkout"],' +
          'input[name="checkout"],' +
          'a[href$="/checkout"]'
        );


      if (!checkoutElement) {
        return;
      }


      /*
       * Allow the second click generated by this script
       * after successful validation.
       */

      if (
        checkoutElement.dataset.giftWrapValidated === 'yes'
      ) {

        delete checkoutElement.dataset.giftWrapValidated;

        return;
      }


      event.preventDefault();
      event.stopImmediatePropagation();


      try {

        const cart = await getCart();

        const wrappingItems =
          cart.items.filter(isGiftWrap);

        /*
         * No gift wrapping in this cart.
         * Normal order — continue normally.
         */

        if (wrappingItems.length === 0) {

          continueCheckout(checkoutElement);

          return;
        }


        /*
         * Find all products other than the
         * gift-wrapping product.
         */

        const realProducts =
          cart.items.filter(function (item) {

            return !isGiftWrap(item);

          });


        /*
         * Wrapping cannot be purchased alone.
         */

        if (realProducts.length === 0) {

          showGiftWrapError(
            'Gaveinnpakning kan ikke bestilles alene. ' +
            'Legg til minst ett annet produkt før du går til kassen.',
            checkoutElement
          );

          return;
        }


        /*
         * Everything is valid.
         */

        continueCheckout(checkoutElement);


      } catch (error) {

        console.error(error);

        showGiftWrapError(
          'Vi klarte ikke å kontrollere handlekurven. ' +
          'Oppdater siden og prøv igjen.',
          checkoutElement
        );

      }

    },

    true

  );

})();